import React from 'react';

import { Button } from '@cuemath/web-comps';
import BallLoader from 'comps/ball-loader';

import PayoutGrid from './payout-grid';
import { Empty, FieldError, SubmitRow } from '../styled-comps';

// The results area below the filters: loader / empty state, the rates grid, and the
// primary action (region "Edit end date" in view mode, "Review & create" in bulk mode).
const PayoutBody = ({
  isBulk,
  loading,
  activeRegion,
  visibleGradeRanges,
  visibleTiers,
  cellData,
  bulkValues,
  bulkErrors,
  bulkDateError,
  bulkSubmitting,
  onBulkChange,
  onEditEnd,
  onSubmitBulk,
}) => {
  if (loading) return <BallLoader />;
  if (!visibleGradeRanges.length) {
    return <Empty>No rates for this region and ratio.</Empty>;
  }

  return (
    <>
      {!isBulk && (
        <SubmitRow>
          <Button size="small" label="Edit end date" width="180px" onClick={onEditEnd} />
        </SubmitRow>
      )}
      <PayoutGrid
        isBulk={isBulk}
        activeRegion={activeRegion}
        visibleGradeRanges={visibleGradeRanges}
        visibleTiers={visibleTiers}
        cellData={cellData}
        bulkValues={bulkValues}
        bulkErrors={bulkErrors}
        bulkSubmitting={bulkSubmitting}
        onBulkChange={onBulkChange}
      />

      {isBulk && (
        <>
          {bulkDateError && <FieldError>{bulkDateError}</FieldError>}
          <SubmitRow>
            <Button
              size="small"
              label={bulkSubmitting ? 'Creating…' : 'Review & create'}
              width="180px"
              disabled={bulkSubmitting}
              onClick={onSubmitBulk}
            />
          </SubmitRow>
        </>
      )}
    </>
  );
};

export default PayoutBody;
